export type PromotionData = {
  cmpnyCd?: string
  cstId?: string
  nttSn?: number
  prmtType?: string
  bizCd?: string
  bizNm?: string
  nttSj?: string
  nttCn?: string
  prmtStartDate?: string
  prmtEndDate?: string
  prmtUrl?: string
  thumbnailSeq?: number | null
  readngCnt?: number
  adminDelYn?: string
  tpPrmtYn?: string
  popupYn?: string
  delYn?: string
  useYn?: string
  page?: number
  pageStart?: number
  pageEnd?: number
  fileSeq?: number
  fileNm?: string
  fileUrl?: string
  prmtNttSn?: number
  prmtFileSeq?: number
  prmtFileName?: string
  fileSeqList?: number[]
  fileNameList?: string[]
  fileSourceList?: string[]
  deleteSeqList?: number[]
  srchOpt?: string
  srchStr?: string
  regId?: string
  regDate?: string
  updId?: string
  updDate?: string
  nickName?: string
  withDrawYn?: string
  thumbnailUrl?: string
  thumbnail?: string
  fileOrgNm?: string
  previousThumbnailSeq?: number
}

export type GolfInfoData = {
  cmpnyCd: string
  bizNm?: string
  bizCd?: string
  areaCd?: string
  remark?: string
  useYn: string
}

export type GolfArea = {
  areaCd: string
  remark: string
}

export type GolfBizNm = {
  areaCd: string
  bizNm: string
  bizCd: string
}

export type GetPromotionData = {
  promoType?: string
  statusType?: string
  keywordTypes?: string
  keyword?: string
  areaCd?: string
  srchOpt?: string
  srchStr?: string
  page: number
  bbsSj?: string
}
export const PromotionTitle = '정보'

export const PromoType = [
  { label: '전체', value: '00' },
  { label: '골프장', value: '01' },
  { label: '스크린', value: '02' },
  { label: '기타', value: '03' },
]

export const StatusType = [
  { label: '전체', value: '00' },
  { label: '예정', value: '03' },
  { label: '진행중', value: '01' },
  { label: '마감', value: '02' },
]

export const KeywordType = [
  { label: '제목', value: 'nttSj' },
  { label: '내용', value: 'nttCn' },
  { label: '골프장명', value: 'bizNm' },
]

export const ThumbnailType = [
  { label: '직접 등록', value: 'custom' },
  { label: '이미지 없음', value: 'default' },
]

export const fieldCheck = {
  bbsSj: '말머리를 선택해 주세요.',
  nttSj: '프로모션명을 입력해 주세요.',
  nttCn: '프로모션내용을 입력해 주세요.',
  prmtType: '프로모션 구분을 선택해 주세요.',
  prmtStartDate: '프로모션 시작일을 선택해 주세요.',
  prmtEndDate: '프로모션 종료일을 선택해 주세요.',
  thumbnail: '대표 이미지를 업로드한 후 저장해 주세요.',
}

export const options = [
  { value: '', label: '말머리 선택' },
  { value: '01', label: '말머리1' },
  { value: '02', label: '말머리2' },
  { value: '03', label: '말머리3' },
]

export const thumbnailSizeInfo =
  '* 직접 등록 시 가로 1200px × 세로 596px 크기를 권장해요.'

// 디테일에서 수정 넘어갈 때, 시분초 제외
export const formatDate = (date: string, dot?: boolean) => {
  const [datePart] = date.split(' ') // 시간 제외

  if (dot) {
    const [year, month, day] = datePart.split('-')
    return [year, month, day].join('.')
  }

  return datePart
}
